function openTab(evt, tabName) {
  var i, tabcontent;

  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  document.getElementById(tabName).style.display = "block";
  aboutTabsUpdateClasses(evt.currentTarget.dataset.name);

  document.getElementsByClassName("tabs-wrapper")[0].scrollIntoView(top);
}

function aboutTabsUpdateClasses(current) {
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  for (i = 0; i < tablinks.length; i++) {
    if (tablinks[i].dataset.name === current) {
      tablinks[i].className += " active";
    }
  }
}

if (location.hash === "#kei") {
  let event = new Event("click");
  document.getElementById("ourStoryTab").dispatchEvent(event);
}
